import { render } from "./Assemble.vue?vue&type=template&id=388b22fa"
import script from "./Assemble.vue?vue&type=script&lang=js"
export * from "./Assemble.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__